export default "__VITE_ASSET__DA4NC9Bh__"